import { WishlistItem, WishlistResponseData } from '@aboutyou/backbone';
import { NotificationPayload } from 'modules/shop/notificationManager/types';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import { ClientPageType } from 'src/app/types';

export interface CustomWishlistItem extends WishlistItem {
  variantId?: number;
  adaptedProduct?: IAdaptedProduct;
}

export interface WishList extends WishlistResponseData {
  items: CustomWishlistItem[];
}

export interface WishlistState {
  total: number;
  wishlistId: string | null;
  wishlist: WishList | null;
  addToWishlist: (
    variantId: number,
    payload: NotificationPayload,
    pageType?: ClientPageType,
  ) => void;
  removeFromWishlist: (
    itemKey: string,
    payload: NotificationPayload,
    pageType?: ClientPageType,
  ) => void;
  getWishlist: () => void;
  loading: boolean;
}

export enum WishlistActions {
  ADD = 'wishlist-add',
  REMOVE = 'wishlist-remove',
}
